
    <div class="modal-header modal-header-danger">
      <h4 class="modal-title">
        <a><i id="close_error_modal_link" class="fa fa-times" (click)="close()"></i></a>
        <span class="text-content-wrap">
          <i class="fa fa-exclamation-circle"></i>
          {{ title | translate }}
        </span>
      </h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p translate [translateParams]="bodyParams" class="text-content-wrap">{{body}}</p>
          <pre *ngIf="error">{{error | json}}</pre>
        </div>
        <div class="col-md-12 text-content-wrap" *ngIf="nonTranslatableMessage">
          <p>{{ nonTranslatableMessage }}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="close_error_modal_button" type="button" class="btn btn-action" (click)="close()" translate>Close</button>
    </div>
  